import Utility from "../utility/utility";
import AppData from "../pacakge/public/const/app_data";
import GameUtil from "../utility/game_util";
import LoaclStorage from "../manager/local_storage";
import TimeManager from "../manager/time_manager";
import EventManager from "../manager/event_manager";
import AudioManager from "../manager/audio_manager";
import ModuleManager from "../framework/core/module_manager";
import LanguageManager from "../manager/language_manager";
// import Test from "../pacakge/hall/module/test/test";
/**
 * 非sdk调用 请求/接收 接口写在这里
 */
export default class AppController extends cc.Component {

    private static _instance: AppController;
    public static get instance(): AppController {

        if (!AppController._instance) {

            AppController._instance = new AppController();
        }
        return AppController._instance;
    }

    private _loadGoogleRewardAdReadyCallback: Function
    private _loadGoogleRewardError: Function
    private _rewardedVideoShowFinish: boolean
    private _rewardedVideoClose: Function

    private _getOpenInstallDataCallback: Function

    static _lastBuglySetId


    public receive(content: string, encode = true) {

        // cc.log(" AppHandler receive " + content, " encode " + encode);
        let json = JSON.parse(encode ? Utility.decodeBase64(content) : content);
        cc.log(" AppHandler encode receive " + json.funcName, " param " + json.param);
        if (json.funcName == "backPressed") {

            this.backPressed();
        } else if (json.funcName == "OnCancelPhotoCallback") {
            cc.log("取消选择")
            EventManager.instance.dispatch('OnCancelPhotoCallback');
        } else if (json.funcName == "OnShowPhotoCallback") {
            let img = JSON.parse(json.param)
            EventManager.instance.dispatch('OnShowPhotoCallback', img);
        } else if (json.funcName == "getOpenInstallData") {
            let od = JSON.parse(json.param)
            cc.log("openinstall 数据:", od.channelCode, od.appData)
            if (typeof od.appData == "undefined" || od.appData == null || od.appData == "") {
                this.processOpeninstallData("")
            } else {
                let codeJson = JSON.parse(od.appData)
                if (codeJson.hasOwnProperty("inviteCode")) {
                    this.processOpeninstallData(codeJson.inviteCode)
                    Utility.reportConversionEvent("get_openinstall_data")
                } else {
                    this.processOpeninstallData("")
                }
            }
        } else if (json.funcName == "openInstallWakeupData") {
            let od = JSON.parse(json.param)
            cc.log("openinstall 唤起数据:", od.channelCode, od.appData)
            if (typeof od.appData == "undefined" || od.appData == null || od.appData == "") {
                // cc.systemEvent.emit("openInstallWakeupData", "")
            } else {
                let codeJson = JSON.parse(od.appData)
                if (codeJson.hasOwnProperty("inviteCode")) {
                    this.processOpeninstallData(codeJson.inviteCode)
                    Utility.reportConversionEvent("get_openinstall_wakeupdata")
                }
            }
        } else if (json.funcName == "urlWakeApp") {
            cc.log("url scheme 唤起参数:", json.param)
            cc.systemEvent.emit("urlWakeApp", json.param)
        } else if (json.funcName == "setOrientationCallback") {
            cc.log("设置屏幕方向回调", json.param)
            if (json.param == "1") {
                this.setViewFrame()
            }
        } else if (json.funcName == "installReferrerResponse") {
            cc.log("installReferrerResponse", json.param)
        }
        else if (json.funcName == "googleRewardAdsCallback") {
            cc.log("googleRewardAdsCallback", json.param)
            this.googleRewardAdReturn(json.param)
        } if (json.funcName == "facebookRewardAdsCallback") {
            cc.log("facebookRewardAdsCallback", json.param)
            this.googleRewardAdReturn(json.param)
        } else if (json.funcName == "FirebaseRegistrationToken") {
            cc.log("firebase message token:", json.param)
            // this.copyTextToClipboard(json.param)
        }
    }

    /**
     * 
     * @param funcName 
     * @param jsonParam 
     */
    public requestNativeFunc(funcName: string, jsonParam: string = "") {
        if (!CC_JSB) {
            return
        }

        let jsonObj = {
            "funcName": funcName,
            "params": jsonParam
        };

        let jsonStr = JSON.stringify(jsonObj);

        if (cc.sys.os == cc.sys.OS_ANDROID) {

            let className = "project/sdk/MainSDKActivity";
            jsb.reflection.callStaticMethod(className, "receiveJSCall", "(Ljava/lang/String;)V", jsonStr);
        }
        else if (cc.sys.os == cc.sys.OS_IOS) {

            let className = "AppController";
            let result = jsb.reflection.callStaticMethod(className, "receiveJSCall:", jsonStr);
        }
    }

    /**
 * 
 * @param funcName 
 * @param jsonParam 
 */
    public requestNativeFuncReturn(funcName: string, jsonParam: string = ""): string {
        if (!CC_JSB) {
            return
        }

        let jsonObj = {
            "funcName": funcName,
            "params": jsonParam
        };

        let jsonStr = JSON.stringify(jsonObj);
        let result: string
        if (cc.sys.os == cc.sys.OS_ANDROID) {

            let className = "project/sdk/MainSDKActivity";
            result = jsb.reflection.callStaticMethod(className, "receiveJSCallReturn", "(Ljava/lang/String;)Ljava/lang/String;", jsonStr);
        }
        else if (cc.sys.os == cc.sys.OS_IOS) {

            let className = "AppController";
            result = jsb.reflection.callStaticMethod(className, "receiveJSCallReturn:", jsonStr);
        } else {
            result = ""
        }
        cc.log("requestNativeFuncReturn", funcName, jsonParam, result)
        return result
    }

    public setViewFrame() {
        cc.log("setFrameSize")
        var s = cc.view.getFrameSize()
        cc.view.setFrameSize(s.width, s.height)
    }
    //设置手机的旋转方向1：横屏，2：竖屏
    public setOrientation(orientation: number) {

        if (cc.sys.isBrowser) {


        } else if (cc.sys.os == cc.sys.OS_ANDROID || cc.sys.os == cc.sys.OS_IOS) {
            if (orientation == 1) {
                cc.view.setOrientation(cc.macro.ORIENTATION_LANDSCAPE)
            } else {
                cc.view.setOrientation(cc.macro.ORIENTATION_PORTRAIT)
            }

            this.requestNativeFunc("setOrientation", orientation.toString());
        }
    }

    public startWebview(url: string) {
        this.requestNativeFunc("startWebview", url)
    }
    //从剪贴板中获取文本
    public getTextFromClipboard(): string {
        if (cc.sys.isBrowser) {
            return ""
        } else {
            return this.requestNativeFuncReturn("getTextFromClipboard")
        }

    }

    public getFirebaseMessageToken() {
        if (CC_JSB) {
            this.requestNativeFunc("firbaseRegisterToken", "")
        }
    }
    public registerForRemoteNotification() {
        if (CC_JSB) {
            this.requestNativeFunc("registerForRemoteNotification", "")
        }
    }
    //创建通知渠道
    public createNotificationChannel(channelId, channelName, importance) {
        if (CC_JSB && cc.sys.os == cc.sys.OS_ANDROID) {
            let jsonObj = {
                "channelId": channelId,
                "channelName": channelName,
                "storeImageimportanceName": importance
            };


            let jsonStr = JSON.stringify(jsonObj);
            this.requestNativeFunc("createNotificationChannel", jsonStr)
        }
    }
    public sendNotification(title, message, channelId?) {
        if (CC_JSB && cc.sys.os == cc.sys.OS_ANDROID) {
            let jsonObj = {
                "title": title,
                "message": message,
                "channel": channelId ? channelId : ""
            };

            let jsonStr = JSON.stringify(jsonObj);
            this.requestNativeFunc("sendNotification", jsonStr)
        }
    }

    public copyTextToClipboard(str: string) {
        if (cc.sys.isNative) {
            this.requestNativeFunc("copyTextToClipboard", str)
        }
        else if (cc.sys.isBrowser) {
            //增加web文字复制 主要方便推广链接
            var textArea = document.getElementById("clipBoard");
            if (textArea === null) {
                textArea = document.createElement("textarea");
                textArea.id = "clipBoard";
                textArea.textContent = str;
                document.body.appendChild(textArea);
            }
            //@ts-ignore
            textArea.select();
            try {
                const msg = document.execCommand('copy') ? 'successful' : 'unsuccessful';
                document.body.removeChild(textArea);
            } catch (err) {
            }
        }

    }
    public startApp(app: string) {

        this.requestNativeFunc("startApp", app)
    }
    public isAppExist(app: string) {
        return this.requestNativeFuncReturn("isAppExist", app)
    }
    //保存图片到相册
    public saveImageToGallery(sourceImagePath: string, dcimName: string, storeImageName: string) {
        let jsonObj = {
            "sourceImagePath": sourceImagePath,
            "dcimName": dcimName,
            "storeImageName": storeImageName
        };

        let jsonStr = JSON.stringify(jsonObj);
        if (cc.sys.os == cc.sys.OS_IOS) {
            jsonStr = sourceImagePath
        }
        this.requestNativeFunc("saveImageToGallery", jsonStr)
    }

    public openCamera(width: number, height: number) {
        let jsonObj = {
            "width": width,
            "height": height
        };
        let jsonStr = JSON.stringify(jsonObj);
        this.requestNativeFunc("OpenPhoto", jsonStr)

    }
    public openAlbum(width: number, height: number) {
        let jsonObj = {
            "width": width,
            "height": height
        };
        let jsonStr = JSON.stringify(jsonObj);
        this.requestNativeFunc("OpenPick", jsonStr)
    }
    public GetInstallReferrer() {
        if (CC_JSB) {
            this.requestNativeFunc("GetInstallReferrer", "")
        }
    }
    public requestOpeninstallData(callback?) {
        this._getOpenInstallDataCallback = callback
        let localCode = LoaclStorage.getString("__openInstallInstallData", "")
        if (localCode != "") {
            this.processOpeninstallData(localCode)
        }
        if (CC_JSB) {
            this.requestNativeFunc("getOpenInstallData", "")
        } else {
            let p = GameUtil.GetUrlParameter(AppData.openUrl)
            let jp = JSON.parse(JSON.stringify(p))
            if (typeof jp == "undefined" || jp == null || jp == "") {
                this.processOpeninstallData("")
            } else {
                if (jp.hasOwnProperty("inviteCode")) {
                    this.processOpeninstallData(jp.inviteCode)
                } else {
                    this.processOpeninstallData("")
                }
            }
        }
    }
    public openLineChat(lineID) {
        // line://ti/p/@238hjrcl
        let url = "line://ti/p/@" + lineID
        if ((cc.sys.os == cc.sys.OS_ANDROID && Utility.version_judge(AppData.appVersion, "2.1.0"))) {
            if (AppController.instance.isAppExist("jp.naver.line.android")) {
                AppController.instance.startApp(url)
            } else {
                ModuleManager.instance.toast(LanguageManager.t("install_line"))
            }
        } else if (cc.sys.os == cc.sys.OS_IOS && Utility.version_judge(AppData.appVersion, "2.1.0")) {
            if (AppController.instance.isAppExist("line://")) {
                AppController.instance.startApp(url)
            } else {
                ModuleManager.instance.toast(LanguageManager.t("install_line"))
            }
        } else {
            cc.sys.openURL(url)
        }
    }

    public openFacebookUrl(url, id) {
        if (!CC_JSB) {
            cc.sys.openURL(url)
        } else {
            if ((cc.sys.os == cc.sys.OS_ANDROID && Utility.version_judge(AppData.appVersion, "2.1.0"))) {
                if (AppController.instance.isAppExist("jp.naver.line.android")) {
                    AppController.instance.startApp(`fb://faceweb/f?href=${url}`)
                } else {
                    cc.sys.openURL(url)
                }
            } else if (cc.sys.os == cc.sys.OS_IOS && Utility.version_judge(AppData.appVersion, "2.1.0")) {
                if (AppController.instance.isAppExist("line://")) {
                    AppController.instance.startApp(`fb://profile/${id}`)
                } else {
                    cc.sys.openURL(url)
                }
            } else {
                cc.sys.openURL(url)
            }
        }
    }

    public clearIosNotification() {
        if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
            this.requestNativeFunc("clearNotification", "")
        }
    }

    public processOpeninstallData(data) {
        if (data != "") {
            LoaclStorage.setString("__openInstallInstallData", data)
            cc.systemEvent.emit("openinstallInstallCode", data)
            this._getOpenInstallDataCallback && this._getOpenInstallDataCallback(data)
            this._getOpenInstallDataCallback = null
            AppData.setOpeninstallData(data)
        }
    }

    public openInstallReportEffectPoint(pointId: string, pointValue: number = 1) {
        if (AppData.userConnectEnvi != 0) {
            return
        }
        let jsonObj = {
            "pointId": pointId,
            "pointValue": pointValue
        };

        let jsonStr = JSON.stringify(jsonObj);
        this.requestNativeFunc("openInstallReportEffectPoint", jsonStr)
    }

    private backPressed() {
        cc.systemEvent.emit("onBackPressed")
    }

    //创建压缩文件 成功返回 success
    public createZipFile(sourceFilePath: String, targetPath: String, zipFileName: String): String {
        let jsonObj = {
            "sourceFilePath": sourceFilePath,
            "targetPath": targetPath,
            "zipFileName": zipFileName
        };
        let jsonStr = JSON.stringify(jsonObj);
        return this.requestNativeFuncReturn("createZipFile", jsonStr)
    }

    public buglyTest() {
        this.requestNativeFunc("buglyTest")
    }
    public setBuglyUserid(id: string) {
        if (AppController._lastBuglySetId != id) {
            this.requestNativeFunc("setBuglyUserId", id)
            AppController._lastBuglySetId = id
        }
    }
    //{model="",os="",deviceId=""}
    public deviceInfo() {
        let localInfo = LoaclStorage.getString("localDevicesInfo", "")
        if (localInfo == "") {
            let od
            if (CC_JSB) {
                if (CC_PREVIEW) {
                    return
                }
                let data = this.requestNativeFuncReturn("deviceInfo")
                od = JSON.parse(data)
                od.deviceId = Utility.isNativeAndroid() ? "A-" + od.deviceId : "I-" + od.deviceId
                if (od.deviceId == "A-" || od.deviceId == "I-") {
                    let localId = LoaclStorage.getString("localDevicesId", "")
                    if (localId == "") {
                        od.deviceId = Math.random().toString(36).substring(2)
                        od.deviceId = Utility.isNativeAndroid() ? "A-" + od.deviceId : "I-" + od.deviceId
                        LoaclStorage.setString("localDevicesId", od.deviceId)
                    } else {
                        od.deviceId = localId
                    }
                }
            } else {
                // let deviceId = Utility.getCanvasFingerprint()
                let deviceId = Math.random().toString(36).substring(2)
                od = {
                    "model": navigator.userAgent,
                    "os": navigator.platform,
                    "deviceId": "W-" + deviceId
                }
            }
            LoaclStorage.setString("localDevicesInfo", JSON.stringify(od))
            cc.log("get", JSON.stringify(od))
            return od
        } else {
            cc.log("local", JSON.stringify(localInfo))
            return JSON.parse(localInfo)
        }
    }

    //param {
    //     AnalyticsParam : "string",
    // }
    public trackerEvent(event: AnalyticsEvent, param: AnalyticsParam) {
        if (!CC_JSB) {
            return
        }
        let jsonObj = {
            "event": event,
            "param": JSON.stringify(param)
        };
        let jsonStr = JSON.stringify(jsonObj);
        this.requestNativeFunc("trackerEvent", jsonStr)
    }
    public setFirebaseUserId(userId: string) {
        this.requestNativeFunc("setFirebaseUserId", userId)
    }
    public installApk(path) {
        if (CC_JSB && cc.sys.os == cc.sys.OS_ANDROID) {
            this.requestNativeFunc("installApk", path)
        }

    }

    public setFBSDKAppEvents(eventName: string, params?: Object) {
        let jsonStr = JSON.stringify({
            eventName: eventName,
            params: params
        });
        this.requestNativeFunc("setFBSDKAppEvents", jsonStr)
    }


    public showRewardAd(userGoogleAd, productId: string, showFinish?) {
        cc.warn(userGoogleAd, productId)
        if (CC_JSB) {
            if (userGoogleAd) {
                this.showGoogleRewardAd(productId, showFinish)
            } else {
                this.showFacebookRewardAd(productId, showFinish)
            }
        } else {
            showFinish && showFinish()
        }
    }




    public showGoogleRewardAd(productId: string, showFinish?) {
        if (CC_JSB) {
            this._loadGoogleRewardAdReadyCallback = null
            this._rewardedVideoShowFinish = false
            this._rewardedVideoClose = showFinish
            let canShow = this.requestNativeFuncReturn("showGoogleRewardAd")
            cc.log("showGoogleRewardAd.canShow", canShow)
            if (canShow != "true") {
                this._loadGoogleRewardAdReadyCallback = (errorCode) => {
                    if (errorCode == null) {
                        canShow = AppController.instance.requestNativeFuncReturn("showGoogleRewardAd")
                    } else {
                        showFinish && showFinish(errorCode)
                    }
                    this._loadGoogleRewardAdReadyCallback = null
                };
                AppController.instance.requestNativeFuncReturn("loadGoogleRewardAd", productId)
            }
        } else {
            showFinish && showFinish()
            showFinish = null
        }
    }

    public showFacebookRewardAd(productId: string, showFinish?) {
        if (CC_JSB) {
            this._loadGoogleRewardAdReadyCallback = null
            this._rewardedVideoShowFinish = false
            this._rewardedVideoClose = showFinish
            let canShow = this.requestNativeFuncReturn("showFacebookRewardAd")
            if (canShow != "true") {
                this._loadGoogleRewardAdReadyCallback = (errorCode) => {
                    if (errorCode == null) {
                        canShow = AppController.instance.requestNativeFuncReturn("showFacebookRewardAd")
                        if (Utility.isNativeIOS() && canShow) {
                            AudioManager.instance.pauseMusic()
                        }
                    } else {
                        showFinish && showFinish(errorCode)
                    }
                    this._loadGoogleRewardAdReadyCallback = null
                };
                AppController.instance.requestNativeFuncReturn("loadFacebookRewardAd", productId)
            }
        } else {
            showFinish && showFinish()
            showFinish = null
        }
    }

    public clearVideoAdertRewardCallback() {
        this._loadGoogleRewardAdReadyCallback = null;
        this._rewardedVideoShowFinish = false;
        this._rewardedVideoClose = null;
    }

    public requestEvaluate() {
        if (CC_JSB) {
            if (cc.sys.os == cc.sys.OS_IOS) {
                let url = "itms-apps://apps.apple.com/us/app/%E0%B8%9C-%E0%B8%8A%E0%B8%99%E0%B8%B0%E0%B9%83%E0%B8%AB%E0%B8%8D-%E0%B9%80%E0%B8%81%E0%B8%A1%E0%B9%84%E0%B8%9E/id1498593272?l=zh&ls=1&action=write-review"
                cc.sys.openURL(url)
            } else if (cc.sys.os == cc.sys.OS_ANDROID) {
                if (Utility.version_judge(AppData.appVersion, "1.2.6")) {
                    this.startApp("market://details?id=com.bigwin.dayingjia")
                } else {
                    let url = "https://play.google.com/store/apps/details?id=com.bigwin.dayingjia"
                    cc.sys.openURL(url)
                }
            }
        }
    }

    googleRewardAdReturn(result) {
        cc.log("googleRewardAdReturn deal", result)
        let json: any = Utility.jsonParse(result)
        let state = json ? json.state : result

        switch (state) {
            case "onRewardedVideoAdReady":  //广告已经准备好了，可以播放了
                this._loadGoogleRewardAdReadyCallback && this._loadGoogleRewardAdReadyCallback()
                this._loadGoogleRewardAdReadyCallback = null
                break
            case "startShow":
                break
            case "onRewardedVideoAdOpened":
                Utility.isNativeIOS() && AudioManager.instance.pauseMusic()
                break
            case "onRewardPresent":
                Utility.isNativeIOS() && AudioManager.instance.pauseMusic()
                break
            case "onRewardedVideoStarted":
                break
            case "onRewardedVideoAdClosed":  //广告被关闭，可以监控次事件来触发是否获取奖励
                this._rewardedVideoClose && this._rewardedVideoClose(!this._rewardedVideoShowFinish ? -999 : null)
                this._rewardedVideoClose = null
                Utility.isNativeIOS() && AudioManager.instance.resumeMusic()
                break
            case "onRewarded":
                this._rewardedVideoShowFinish = true
                break
            case "onRewardedVideoAdLeftApplication":
                break
            case "onRewardedVideoAdFailedToLoad":  //加载失败，需要返回errorCode
                let errorCode = json ? json.errorCode : null
                if (errorCode) {
                    this._loadGoogleRewardAdReadyCallback && this._loadGoogleRewardAdReadyCallback(errorCode)
                    this._loadGoogleRewardAdReadyCallback
                }
                break
            case "onRewardedAdFailedToShow":
                break
            case "onRewardedVideoCompleted":  //播放完成
                this._rewardedVideoShowFinish = true
                break
        }
    }

    // 0 true 1 false
    public setHTTPSRequestEnabled(enabled: number) {
        if (CC_JSB) {
            this.requestNativeFunc("setHTTPSRequestEnabled", enabled + "")
        }
    }
    public setCachedIPEnabled(enabled: number) {
        if (CC_JSB) {
            this.requestNativeFunc("setCachedIPEnabled", enabled + "")
        }
    }
    public setTimeoutInterval(time: string) {
        if (CC_JSB) {
            this.requestNativeFunc("setTimeoutInterval", time)
        }
    }
    public getIpByHostAsync(host: string): string {
        if (CC_JSB) {
            let ip: string = this.requestNativeFuncReturn("getIpByHostAsync", host)
            cc.log("httpdns获取ip，host:", host, "ip:", ip)
            return ip
        } else {
            return host
        }
    }
    public getIpsByHostAsync(host: string): string[] {
        if (CC_JSB) {
            let ips: string = this.requestNativeFuncReturn("getIpsByHostAsync", host)
            cc.log("httpdns获取ip，host:", host, "ip:", ips)
            let ipArray: string[]
            if (ips == "") {
                ipArray = []
            } else {
                ipArray = ips.split(":")
            }
            return ipArray
        } else {
            return [host]
        }
    }

    public getLaunchUrlParameter() {
        let str: string = this.requestNativeFuncReturn("getLaunchUrlParameter")
        cc.log("启动参数：", str)
        return str;
        // if (str = ""){
        //     return {}
        // }else{
        //     return JSON.parse(str) 
        // }
    }

    public ccStart() {

        this.requestNativeFunc("ccStart")
    }

    // public savePicture() {
    //     var Url = $("#picurl").attr("src");
    //     var blob = new Blob([''], { type: 'application/octet-stream' });
    //     var url = URL.createObjectURL(blob);
    //     var a = document.createElement('a');
    //     a.href = Url;
    //     a.download = Url.replace(/(.*\/)*([^.]+.*)/ig, "$2").split("?")[0];
    //     var e = document.createEvent('MouseEvents');
    //     e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    //     a.dispatchEvent(e);
    //     URL.revokeObjectURL(url);
    // }
    /**
 * 在本地进行文件保存
 * @param  {String} data     要保存到本地的图片数据
 * @param  {String} filename 文件名
 */
    saveFile(data, filename) {
        const save_link: any = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        save_link.href = data;
        save_link.download = filename;

        const event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        save_link.dispatchEvent(event);
    }
}
//@ts-ignore
window.appController = AppController.instance;

export enum AnalyticsEvent {
    ADD_PAYMENT_INFO = "add_payment_info",
    ADD_TO_CART = "add_to_cart",
    ADD_TO_WISHLIST = "add_to_wishlist",
    APP_OPEN = "app_open",
    BEGIN_CHECKOUT = "begin_checkout",
    CAMPAIGN_DETAILS = "campaign_details",
    ECOMMERCE_PURCHASE = "ecommerce_purchase",
    GENERATE_LEAD = "generate_lead",
    JOIN_GROUP = "join_group",
    LEVEL_END = "level_end",
    LEVEL_START = "level_start",
    LEVEL_UP = "level_up",
    LOGIN = "login",
    POST_SCORE = "post_score",
    PRESENT_OFFER = "present_offer",
    PURCHASE_REFUND = "purchase_refund",
    SEARCH = "search",
    SELECT_CONTENT = "select_content",
    SHARE = "share",
    SIGN_UP = "sign_up",
    SPEND_VIRTUAL_CURRENCY = "spend_virtual_currency",
    TUTORIAL_BEGIN = "tutorial_begin",
    TUTORIAL_COMPLETE = "tutorial_complete",
    UNLOCK_ACHIEVEMENT = "unlock_achievement",
    VIEW_ITEM = "view_item",
    VIEW_ITEM_LIST = "view_item_list",
    VIEW_SEARCH_RESULTS = "view_search_results",
    EARN_VIRTUAL_CURRENCY = "earn_virtual_currency",
    REMOVE_FROM_CART = "remove_from_cart",
    CHECKOUT_PROGRESS = "checkout_progress",
    SET_CHECKOUT_OPTION = "set_checkout_option",
}

export interface AnalyticsParam {
    achievement_id?: string
    character?: string
    travel_class?: string
    content_type?: string
    currency?: string
    coupon?: string
    start_date?: string
    end_date?: string
    extend_session?: string
    flight_number?: string
    group_id?: string
    item_category?: string
    item_id?: string
    item_location_id?: string
    item_name?: string
    location?: string
    level?: string
    level_name?: string
    sign_up_method?: string
    method?: string
    number_of_nights?: string
    number_of_passengers?: string
    number_of_rooms?: string
    destination?: string
    origin?: string
    price?: string
    quantity?: string
    score?: string
    shipping?: string
    transaction_id?: string
    search_term?: string
    success?: string
    tax?: string
    value?: string | number
    virtual_currency_name?: string
    campaign?: string
    source?: string
    medium?: string
    term?: string
    content?: string
    aclid?: string
    cp1?: string
    item_brand?: string
    item_variant?: string
    item_list?: string
    checkout_step?: string
    checkout_option?: string
    creative_name?: string
    creative_slot?: string
    affiliation?: string
    index?: string
    uid?: string
}